import { IThemeSemantics, IPalette } from '../types';

const palette: IPalette = {
    themeDark: '#005FAE',
    themeDarkAlt: '#006BC3',
    themeDarker: '#005398',
    themeLight: '#4DA0E5',
    themeLighter: '#80BBEC',
    themeLightAlt: '#BFDDF5',
    themeLighterAlt: '#E6F2FB',
    themePrimary: '#0077D9',
    themeSecondary: '#1A85DD',
    themeTertiary: '#3392E1',
    neutralLighterAlt: '#F9F9FA',
    neutralLighter: '#F5F5F6',
    neutralLight: '#F0F0F2',
    neutralQuaternaryAlt: '#dadada',
    neutralQuaternary: '#ECEDEE',
    neutralTertiaryAlt: '#c8c8c8',
    neutralTertiary: '#D8DADD',
    neutralSecondary: '#898F99',
    neutralSecondaryAlt: '#B1B4BB',
    neutralPrimary: '#3B4455',
    neutralPrimaryAlt: '#626977',
    neutralDark: '#353D4C',
    neutralDarker: '#2F3644',
    black: '#000',
    accent: '',
    blackTranslucent40: '#B1B0AF',
    blue: '#006AFF',
    blueDark: '#0078d4',
    blueLight: '#4DB1FF',
    blueMid: '#1d61ff',
    green: '#17803D',
    greenDark: '#126631',
    greenLight: '#32B360',
    magenta: '#B81283',
    magentaDark: '#9E0F71',
    magentaLight: '#D169B0',
    orangeDark: '#A06602',
    orange: '#F16E00',
    orangeLight: '#FF9033',
    orangeLighter: '#FF9E4D',
    purple: '#7D26CD',
    purpleDark: '#651FA6',
    purpleLight: '#B463FF',
    red: '#B6383E',
    redDark: '#9C3035',
    redPale: '#FFF6F7',
    teal: '#218282',
    tealDark: '#1B6969',
    tealLight: '#2EB5B5',
    transparent: 'rgba(0,0,0,0)',
    white: '#FFFFFF',
    whiteTranslucent40: '#ffffffe6',
    yellow: '#FFD800',
    yellowLight: '#FFEE75',
    yellowDark: '#FFBA00'
};

const baseSemantics: IThemeSemantics = {
    palette,
    borderRadius: {
        circle: '100%',
        curvedXLarge: '30px',
        curvedLarge: '8px',
        curvedMedium: '6px',
        curvedSmall: '4px',
        curvedXSmall: '2px',
        sharp: '0px'
    },
    boxShadow: {
        none: 'none',
        xs: '0 0 0 1px',
        s: '0 1px 2px 0',
        normal: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)',
        m: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
        l: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
        xl: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
        xxl: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
        inner: 'inset 0 0 6px rgba(0,0,0,.3)',
        outline: '0 0 0 3px rgba(66, 153, 225, 0.5)'
    },
    colors: {
        bodyTextColor: palette.neutralPrimary,
        mainPageBackgroundColor: palette.neutralLighter,
        layers: {
            canvas: palette.neutralPrimary,
            content: palette.neutralPrimary,
            // input: '#000',
            // inputBackground: '#fff',
            overlay: 'rgba(0,0,0,.5)',
            overlayContent: palette.white,
            canvasBackground: palette.transparent,
            contentBackground: palette.white,
            overlayBackground: palette.transparent,
            overlayContentBackground: palette.white
        },
        scrollbar: {
            scrollHandleColor: '#CECECE',
            scrollContainerColor: '#E4E4E4'
        }
    },
    layout: {
        columnsCount: 12
    },
    stroke: {
        none: '0',
        thin: '1px',
        thick: '2px',
        thicker: '3px'
    },
    gap: {
        none: '0px',
        xs: '1px',
        s: '2px',
        m: '5px',
        l: '10px',
        xl: '16px',
        xxl: '20px',
        xxxl: '25px',
        xxxxl: '30px'
    },
    baseFont: {
        fontFamily: '"Roboto", -apple-system, system-ui, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
        fontSize: '14px'
    }
};

export const getBaseSemantics = () => baseSemantics;
